import { AgxApi } from '../../helpers/http';
import {
  AutoCompleteRequestForSuburbs,
  REXApiSuburbSuggestion,
} from './Types/types';

export const rexApi = (authToken: string) => new AgxApi('rex', authToken);

export const fetchSuburbSuggestionsFromRex = async (
  authToken: string,
  query: string,
  state: string,
  signal: AbortSignal
): Promise<REXApiSuburbSuggestion[] | null> => {
  const { data } = await rexApi(authToken).post<REXApiSuburbSuggestion[]>(
    'GetSuburbs',
    {
      listName: 'suburbs',
      searchString: query,
      state,
    } as AutoCompleteRequestForSuburbs,
    signal
  );

  return data;
};
